import i18n from '@/lang/index'
//详情配置
export const columnObj = {
    PH: [
        {
            prop: 'goodsName',
            label: i18n.t('invoicesCenter.tableconfigGoodsnameV1')
        },
        {
            prop: 'goodsNo',
            label: i18n.t('invoicesCenter.tableconfigGoodsnowithimageV1')
        },
        {
            prop: 'retailPrice',
            label: i18n.t('invoicesCenter.tableconfigRetailpriceV1')
        },
        // {
        //   prop: "price",
        //   label: "铺货价",
        // },
        {
          prop: "colorValue",
          label: i18n.t('invoicesCenter.tableconfigColorV1'),
        },
        {
            prop: 'sizeInfoList',
            width: '1300px',
            boxWidth: '200px' //复选框宽度
        },
        {
            prop: 'total',
            label: i18n.t('invoicesCenter.tableconfigTotalV1'),
            type: 'count',
            getTotal(row, _key) {
                return row.sizeInfoList.reduce((c, R) => c + Number(R[_key] ? R[_key] : 0), 0)
            }
        }
    ]
}
export const sizeInfoLabel = {
    PH: [
        {
            prop: 'number', //复选框key//valueInfoList当前行对应key
            label: i18n.t('invoicesCenter.tableconfigDistributionquantity'), //复选框名称及行数据对应名称
            checkShow: true, //是否出现复选框
            value: true, //绑定值
            disabled: true //禁用
        },
        {
            prop: 'shipmentNumber', //复选框key//valueInfoList当前行对应key
            label: i18n.t('invoicesCenter.tableconfigShipmentquantityV1'), //复选框名称及行数据对应名称
            checkShow: true, //是否出现复选框
            value: true, //绑定值
            disabled: true, //禁用
            colBgc: '#fef8ef'
        },
        {
            prop: 'shipmentDifferenceNumber', //复选框key//valueInfoList当前行对应key
            label: i18n.t('invoicesCenter.tableconfigShipmentdifferenceV1'), //复选框名称及行数据对应名称
            checkShow: true, //是否出现复选框
            value: true, //绑定值
            disabled: true, //禁用
            colBgc: '#fef8ef'
        },
        {
            prop: 'storageNumber', //复选框key//valueInfoList当前行对应key
            label: i18n.t('invoicesCenter.tableconfigStoragequantityV1'), //复选框名称及行数据对应名称
            checkShow: true, //是否出现复选框
            value: true, //绑定值
            disabled: true, //禁用
            colBgc: '#fafef2'
        },
        {
            prop: 'storageDifferenceNumber', //复选框key//valueInfoList当前行对应key
            label: i18n.t('invoicesCenter.tableconfigStoragedifferenceV1'), //复选框名称及行数据对应名称
            checkShow: true, //是否出现复选框
            value: true, //绑定值
            disabled: true, //禁用
            colBgc: '#fafef2'
        }
    ]
}
export const footerObj = {
    PH: [
        'totalAmount',
        'getNum',
        // "phDistriPriceTotal",
        'sellPriceTotal',
        'PHchuhdNumTotal',
        'PHrukudNumTotal'
    ]
}

// 包裹信息
export const packagecolumn = [
    {
        prop: 'goodsCode',
        label: i18n.t('invoicesCenter.tableconfigShortcodeV1'),
    },
    {
        prop: 'goodsNo',
        label: i18n.t('invoicesCenter.tableconfigGoodsnoV1'),
    }, {
        prop: 'goodsName',
        label: i18n.t('invoicesCenter.tableconfigGoodsnameV1'),
    }, {
        prop: 'colorValue',
        label: i18n.t('invoicesCenter.tableconfigColorV1'),
    },
    {
        prop: 'sizeInfoList',
        //复选框宽度
        boxWidth: '30px' //复选框宽度
    },
    {
        prop: 'total',
        label: i18n.t('invoicesCenter.tableconfigQuantityV1'),
        type: 'count',
        getTotal(row, _key) {
            return row.sizeInfoList.reduce((c, R) => c + Number(R[_key] ? R[_key] : 0), 0)
        }
    },
]
export const packageSizeInfoLabels = [
    {
        prop: 'num', //复选框key//valueInfoList当前行对应key
        label: '', //复选框名称及行数据对应名称
        checkShow: false, //是否出现复选框
        value: true, //绑定值
        disabled: true //禁用
    },
]
export const  packageFooterObj=[
    {
        prop: 'totalAmount',
        label: i18n.t('invoicesCenter.tableconfigTotalstyles'),
        unit: i18n.t('invoicesCenter.tableconfigUnitpiece'),
        formula(data) {
            let sum = 0
            data.forEach((item) => {
                for (let i of item.sizeInfoList) {
                    if (+i.num > 0) {
                        sum++
                        break
                    }
                }
            })
            return sum
        }
    },
    {
        prop: 'total',
        label: i18n.t('invoicesCenter.tableconfigTotalitemsV1'),
        unit: i18n.t('invoicesCenter.tableconfigUnititem'),
        formula(data) {
            let sum = 0
            data.forEach((item) => {
                let all = item.sizeInfoList.reduce((c, R) => c + Number(R.num || 0), 0)
                sum += all
            })
            return sum
        }
    },
]
